import LocalizedStrings from "react-localization";

const english = {

    Empty: "",

    Action_OK: "OK",
    Action_Cancel: "Cancel",
    Action_Save: "Save",
    Action_CloseEmailWizard: "Close Email Wizard",
    Action_CloseTemplateWizard: "Close Template Wizard",
    Action_Wizard_Completed: "Sent",
    Action_Email_CCAdd: "Add CC",
    Action_Email_CCRemove: "Remove CC",
    Action_Email_BCCAdd: "Add BCC",
    Action_Email_BCCRemove: "Remove BCC",

    Email_Action_Wizard_Prev_TemplateSelection: "Back to Templates",
    Email_Action_Wizard_Prev_Email: "Back to Email Details",
    Email_Action_Wizard_Prev_Content: "Back to Content",
    Email_Action_Wizard_Next_Content: "Content",
    Email_Action_Wizard_Next_Preview: "Preview",
    Email_Action_Wizard_Submit: "Send",

    Action_Attachments_Add: "Add Attachment",
    Action_Attachments_Remove: "Remove {0}",

    Action_TemplateChange_Confirm: "Change Template",

    Label_Attachments_Button: "Attachments",
    Label_Attachments_CopyAttachmentsToCorrespondence: "Copy To Correspondence",
    Label_Attachments_FileInput: "Attachment file input",
    Label_Yes: "Yes",
    Label_No: "No",
    Label_Error_ClosePopup: "Close Popup",
    Label_Email_Name: "Email Name",
    Label_Email_Name_HelperText: "The email name is shown in your reports",
    Label_Email_Subject: "Subject",
    Label_Email_RecipientAddress: "Recipient Address Type",
    Label_Email_RecipientAddress_HelperText: "Choose which address types to send the email to or manually enter an email address",
    Label_Email_CC: "CC",
    Label_Email_BCC: "BCC",
    Label_Email_FirstOnly: "Send only first email",
    Label_Email_From: "From",
    Label_Email_FromAddress: "From Address",
    Label_Email_ShowInPortal: "Show in Portal",
    Label_Email_To: "To",
    Label_Summary_Attachments: "Attachments",
    Label_Summary_EmailDetails: "Email Details",
    Label_Summary_TemplateDetails: "Template Details",
    Label_Summary_FirstEmail: "(First Email Only)",
    Label_Summary_SendToCount: "(Send to {0} Recipients)",
    Label_Summary_RecipientsTo: "Recipients to",
    Label_Summary_RecipientTo: "Recipients to",
    Label_Summary_Addresses: "Addresses:",
    Label_Summary_Address: "Address:",
    Label_ToAddress_Active: "Active",
    Label_FromAddress_Select: "Select...",

    Label_ParticipantSelector_FieldLabel: "Recipients",
    Label_ParticipantSelector_RecipientType: "Recipients",
    Label_ParticipantSelector_SendToAllInvolved: "Send to all involved",
    Label_ParticipantSelector_SendToAllParticipants: "Send to all participants (excluding managers and unknown participants)",
    Label_ParticipantSelector_SendToSpecificParticipants: "Send to specific participants",
    Label_ParticipantSelector_SelectParticipants: "Choose which participants to send the email to",
    Label_ParticipantSelector_SelectParticipantsInvalid: "Please select some participants",

    Label_Step_EmailDetails_Title: "Email Details",
    Label_Step_EmailDetails_AriaLabel: "Email Details tab",
    Label_Step_EmailContent_Title: "Content",
    Label_Step_EmailContent_AriaLabel: "Content tab",
    Label_Step_EmailPreview_Title: "Preview & Send",
    Label_Step_EmailPreview_AriaLabel: "Preview & Send",

    Message_FieldRequired: "{0} is required",
    Message_Attachment_Uploading: "Uploading",
    Message_Attachment_Deleting: "Deleting",
    Message_Error_General: "An Error Occurred",
    Message_Error_GeneralDescription: "An unknown error has occurred. Please close the wizard and try again.",
    Message_Error_SendEmailsHeader: "Couldn't send Emails for the following:",
    Message_Error_ImageUploadHeader: "Image Upload Error",
    Message_Error_ImageUpload: "Failed to upload image. Please try again.",
    Message_Error_InvalidDynamicText: "Invalid Dynamic Content",
    Message_SendingEmail_ProcessingCaption: "Sending emails",
    Message_SavingTemplate_ProcessingCaption: "Saving Template",
    Message_Preview_LoadingCaption: "Rendering Preview...",
    Message_Preview_EmptyPreview: "Email Body has no content",
    Message_Preview_CopyToCorrespondence: "Attachment(s) will be saved to Communications",
    Message_Wizard_SendToHeaderPlural: "Send email to {0} recipients",
    Message_Wizard_SendToHeader: "Send email to {0} recipient",
    Message_Wizard_SendToConcernHeader: "Send Concern Email",
    Message_Wizard_SendToConductHeader: "Send Conduct Email",
    Message_Wizard_SendToContributionInteractionHeader: "Send Contribution/Interaction Email",
    Message_WizardClose_Editing: "This wizard is not complete and any changes will not be saved.",
    Message_WizardClose_Confirm: "Are you sure you want to cancel?",
    Message_WizardClose_KeepEditing: "Keep Editing",
    Message_WizardClose_CancelWizard: "Cancel Wizard",
    Message_Upload_ErrorHeader: "Upload Errors",
    Message_Upload_Error: "Failed to upload some attachments:",
    Message_Upload_ErrorDuplicate: "Duplicate",
    Message_Upload_ErrorSize_SingleFile: "File too large. Maximum file size is 8 MB",
    Message_Upload_ErrorSize_MultipleFiles: "Files too large. Maximum file size is 8 MB",

    Template_Action_Wizard_Submit: "Save & Finish",
    Template_Action_Wizard_Prev_Email: "Back to Template Details",
    Template_Action_Wizard_Prev_Content: "Back to Content",
    Template_Action_Wizard_Next_Content: "Content",
    Template_Action_Wizard_Next_Preview: "Preview",

    Template_Message_WizardClose_Editing: "Close email template wizard",
    Template_Message_WizardClose_Confirm: "The email template has unsaved changes, are you sure you want to leave?",
    Template_Message_WizardClose_KeepEditing: "Cancel",
    Template_Message_WizardClose_CancelWizard: "Don't save",
    Template_Message_WizardClose_SaveAndCancelWizard: "Save",

    Label_Step_TemplateDetails_Title: "Template Details",
    Label_Step_TemplateDetails_AriaLabel: "Template Details tab",
    Label_Step_TemplateDetails_SubTitle: "Set the basic details for your new email",
    Label_Step_TemplateContent_Title: "Content",
    Label_Step_TemplateContent_AriaLabel: "Content tab",
    Label_Step_TemplatePreview_Title: "Preview & Save",
    Label_Step_TemplatePreview_AriaLabel: "Preview & Save",

    Message_Wizard_TemplateToHeader: "Edit email template {0}",

    Label_Template_Name: "Template Name",

    Message_Wizard_TemplateSave_Success: "Your template has saved successfully",
    Message_Wizard_TemplateSave_NoChanges: "There are no changes to save",

    Message_Wizard_TemplateSelection_TemplateChangeHeader: "Change template?",
    Message_Wizard_TemplateSelection_TemplateChangeBody: "Your email details and content will be lost when you change templates.",
    Message_Wizard_TemplateSelection_TemplateChangeConfirm: "Are you sure you want to change template?",

    Message_Wizard_TemplateSelection_Header_EmptyFolder: "This folder is empty",

    Label_Wizard_TemplateSelection_Header: "Choose a starting point",

    ScribanValidation_Error_Header: "Invalid Content",
    ScribanValidation_Error_Syntax: "There are the following errors with merge fields",
    ScribanValidation_Error_UnknownVariables: "The following merge fields were not recognised",
    ScribanValidation_Error_InaccessibleMemberVariable: "The following merge fields cannot be reached",
    ScribanValidation_Error_MergeFieldNotRecognised: "merge field not recognised",
};

const american = {
};

export const strings = new LocalizedStrings({
    "en": {
        ...english,
    },
    "en-US": {
        ...english, ...american,
    },
});
